module.exports = __webpack_public_path__ + "img/swot.a129aea1.png";